import PropTypes from 'prop-types';
import React from 'react';
import { eventListener } from '../utils';
const [productionId, pageId] = ['101', '10020'];
class Score extends React.Component {
  static propTypes = {
    report: PropTypes.object,
    update: PropTypes.func,
    isSmall: PropTypes.bool,
    role: PropTypes.array,
  };

  state = {};

  reviewDetailBlurEvent = () => {
    let [moduleId, elementId] = ['mk0005', 'ns-005'];
    eventListener({ productionId, pageId, moduleId, elementId });
  };

  render() {
    const { report, isSmall } = this.props;
    const { state } = report;
    return (
      <div className={'report-doctor ' + (isSmall ? 'report-user-small' : '')}>
        <div className="reporter-info">
          <span>申请医生</span>
          <span className={report.reApply ? 'text-red' : ''}>
            {report.applicationUserName}
          </span>
          {report.applicationTime}
          {report.reApply && <span className="text-red">(重复上传)</span>}
        </div>
        {(state >= 20 || state === 12) && (
          <div className="reporter-info">
            <span>报告医生</span>
            <span>{report.reportSignature || '--'}</span>
            {report.reportTime}
          </div>
        )}
        {report.verifySignature && (
          <div className="reporter-info">
            <span>审核医生1</span>
            <span>{report.verifySignature || '--'}</span>
            {report.verifyTime}
          </div>
        )}
        {report.verify2Signature && (
          <div className="reporter-info">
            <span>审核医生2</span>
            <span>{report.verify2Signature || '--'}</span>
            {report.verify2Time}
          </div>
        )}
      </div>
    );
  }
}

export default Score;
